import { HorizontalContainer, IconButton } from '@/components';
import { EditIcon } from '@/components/Icons';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import { PropertyType } from '@/caregiverSpace/shared/model';
import { CopyableField } from '@/caregiverSpace/shared/ui';

type AddPhoneNumberFieldPropertyObjectProps = {
    phoneNumber?: string;
    className?: string;
    phoneCallButton?: React.ReactNode;
    showEditButton?: boolean;
    onEdit?: () => void;
};
export const addPhoneNumberFieldPropertyObject = ({
    phoneNumber,
    className,
    phoneCallButton,
    showEditButton = false,
    onEdit,
}: AddPhoneNumberFieldPropertyObjectProps) => {
    if (!phoneNumber) {
        return null;
    }
    const view = (
        <CopyableField
            fieldType="phoneNumber"
            displayValue={
                showEditButton ? (
                    <HorizontalContainer
                        className="items-center gap-1"
                        spacing="none"
                    >
                        {phoneNumber}
                        <IconButton
                            icon={<EditIcon variant="action" />}
                            onClick={() => onEdit()}
                            tooltip={R.CorrectPhoneNumber}
                        />
                    </HorizontalContainer>
                ) : (
                    phoneNumber
                )
            }
            copyValue={phoneNumber}
            className={className}
        />
    );

    return {
        label: R.Phone,
        value: phoneCallButton ? (
            <HorizontalContainer className="w-full justify-between">
                {view}
                {phoneCallButton}
            </HorizontalContainer>
        ) : (
            view
        ),
        type: PropertyType.CUSTOM,
    };
};
